// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3zV0o","label":"styles_label__1K2ot"};